import "./style.css";

const LandingOverrides = () => null;

export default LandingOverrides;
